import { render, staticRenderFns } from "./ProductosDialog.vue?vue&type=template&id=66ff36ae"
import script from "./ProductosDialog.vue?vue&type=script&lang=js"
export * from "./ProductosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports